import { promotion_list } from "../../../features/company/CampaignApi";
import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Paper,
    Toolbar,
    TableContainer,
    Table,
    TableHead,
    TableCell,
    TableBody,
    TableRow,
    Button,
    Stack,
    IconButton,
    CircularProgress,
    Tooltip,
    Alert,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import PromotionTableitem from "./PromotionTableItem";
import { Add, ReadMore, Refresh, Settings, TableRows } from "@mui/icons-material";
import PromotionAdd from "./PromotionAdd";
import { styled } from "@mui/material/styles";

const MkToolbar = styled(Toolbar)(({ theme }) => ({
    [theme.breakpoints.up("sm")]: {
        padding: "0px",
    },
}));

function PromotionTable({ setTabIndex }) {
    const { promotionList } = useSelector((state) => state.promotions);
    const { campaignInfo } = useSelector((state) => state.campaignDetail);

    const dispatch = useDispatch();
    const [refreshing, setRefreshing] = useState(false);
    const [refreshError, setRefreshError] = useState("");
    const handleRefresh = async () => {
        setRefreshing(true);
        setRefreshError("");
        try {
            await dispatch(promotion_list({ id: campaignInfo.id })).unwrap();
        } catch {
            setRefreshError("Unable to refresh promotions. Please try again.");
        } finally {
            setRefreshing(false);
        }
    };

    return (
        <Box component={Paper} elevation={2} sx={{ mt: 3 }}>
            <Box sx={{ padding: "20px" }}>
                <MkToolbar sx={{ padding: 0 }}>
                    <Typography
                        sx={{ flex: "1 1 100%" }}
                        variant="subtitle1"
                        component="div"
                    >
                        Promotion List
                    </Typography>
                    <Stack direction="row">
                        <Tooltip title="Refresh promotions">
                            <span><IconButton aria-label="Refresh promotions" onClick={handleRefresh} disabled={refreshing || !campaignInfo.id}>
                                {refreshing ? <CircularProgress size={20} /> : <Refresh sx={{ color: "#2152ff" }} />}
                            </IconButton></span>
                        </Tooltip>
                        <PromotionAdd />
                        <IconButton onClick={() => setTabIndex(5)}>
                            <Settings sx={{ color: "#2152ff" }} />
                        </IconButton>
                    </Stack>
                </MkToolbar>
                {refreshError && <Alert severity="error">{refreshError}</Alert>}
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ width: "20%" }}>
                                    <Typography variant="subtitle2">
                                        Image
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{ width: "20%" }}>
                                    <Typography variant="subtitle2">
                                        Title
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{}} align="right">
                                    <Typography variant="subtitle2">
                                        Amount
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{}} align="right">
                                    <Typography variant="subtitle2">
                                        Percent
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{}} align="right">
                                    <Typography variant="subtitle2">
                                        Winning Count
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{}} align="right">
                                    <Typography variant="subtitle2">
                                        Expected Maximum
                                    </Typography>
                                </TableCell>
                                <TableCell
                                    sx={{
                                        display:
                                            campaignInfo.finish === 1
                                                ? "none"
                                                : "",
                                    }}
                                    align="right"
                                >
                                    <Typography variant="subtitle2">
                                        Slient
                                    </Typography>
                                </TableCell>
                                <TableCell
                                    sx={{
                                        display:
                                            campaignInfo.finish === 1
                                                ? "none"
                                                : "",
                                    }}
                                    align="right"
                                >
                                    <Typography variant="subtitle2">
                                        Disabled
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {promotionList.map((item, index) => {
                                return (
                                    <PromotionTableitem
                                        key={index}
                                        item={item}
                                    />
                                );
                            })}
                            <TableRow style={{ height: 85 * 1 }}>
                                <TableCell colSpan={8} />
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    );
}

export default PromotionTable;
